import { useEffect, useState } from "react";
import { Baby, Plus, Truck } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { useSiteImages } from "../context/SiteImagesContext";
import { toast } from "sonner";

export default function Infantil() {
  const { addItem } = useCart();
  const { resolve } = useSiteImages();
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    api.get("/pricing").then(({ data }) => setPricing(data)).catch(() => {});
  }, []);

  if (!pricing?.child_folder) return null;

  const price = pricing.child_folder.price;
  const shipping = pricing?.shipping?.price_es;
  const img = resolve("infantil", "");

  const add = () => {
    addItem({
      key: "infantil",
      kind: "infantil",
      model_id: null,
      model_name: "Carpeta médica infantil VITAE",
      size: null,
      size_label: "Para los más pequeños",
      finish: null,
      finish_label: "",
      specialties: [],
      name_personalization: null,
      price,
      image: img || null,
      pen_hex: "#F2D8C9",
      slug: "infantil",
    });
    toast.success("Carpeta médica infantil añadida al carrito");
  };

  return (
    <section id="infantil" data-testid="infantil-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
          <Reveal>
            <div className="rounded-3xl overflow-hidden bg-gradient-to-br from-[#F2D8C9]/70 to-[#EEF1E8]/70 aspect-[4/5] max-w-md flex items-center justify-center">
              {img ? (
                <img
                  src={img}
                  alt="Carpeta médica infantil VITAE"
                  data-testid="infantil-image"
                  className="w-full h-full object-cover"
                />
              ) : (
                <Baby size={72} weight="thin" className="text-[#D9A88F]" />
              )}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="overline mb-6">
              <span className="text-[#D7C6A3]">09</span> &nbsp;/&nbsp; Para los más pequeños
            </p>
            <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
              Carpeta médica infantil
            </h2>
            <p className="text-[#6B705C] mt-5 font-light leading-relaxed">
              La misma calma y orden de VITAE, pensada para la salud de tus peques.
              Incluye secciones de <strong className="font-normal text-[#2D3732]">pediatría,
              odontología y urgencias médicas</strong>, y un sobre para guardar los{" "}
              <strong className="font-normal text-[#2D3732]">volantes médicos</strong> siempre a mano.
            </p>
            <div className="flex items-baseline gap-3 mt-6">
              <span data-testid="infantil-price" className="font-display text-4xl text-[#2D3732]">
                {price.toFixed(2)} €
              </span>
              {shipping && (
                <span className="text-sm text-[#9CA3AF]">+ envío {shipping.toFixed(2)} €</span>
              )}
            </div>
            <button
              data-testid="infantil-add-btn"
              onClick={add}
              className="mt-6 bg-[#2D3732] hover:bg-[#1f2622] text-white rounded-full px-8 py-4 text-sm transition-colors duration-300 flex items-center gap-2"
            >
              <Plus size={16} /> Añadir al carrito
            </button>
            <p className="text-xs text-[#9CA3AF] mt-5 flex items-center gap-2">
              <Truck size={15} weight="light" />
              Envío estándar o InPost, el mismo que para las carpetas.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
